<!--<div class="col full-height layout-column">-->

<!--  <div *ngIf="!!resources && !!resources?.length" class="flex layout-column dndList overflow-auto">-->

<!--    <app-planning-draft-resources-panel-list-item *ngFor="let resource of resources"-->
<!--                                                  [draft]="draft"-->
<!--                                                  [resource]="resource"-->
<!--                                                  [route]="routesMap[resource.id]"-->
<!--                                                  [settings]="settings"-->
<!--                                                  [isSelected]="selectedKeys[resource.id]"-->
<!--                                                  [itemElementSize]="itemElementSize"-->
<!--                                                  (onToggle)="onToggleSelectedResource(resource.id, $event)">-->

<!--    </app-planning-draft-resources-panel-list-item>-->

<!--  </div>-->

<!--  <div *ngIf="!!resources && !resources?.length"-->
<!--       class="flex layout-row layout-align-center-center fade-element-in-only overflow-auto">-->
<!--    <app-empty-state src="assets/images/empty_state/empty_state_drivers.png"-->
<!--                     text="No Resources Found">-->

<!--    </app-empty-state>-->
<!--  </div>-->

<!--  &lt;!&ndash;Loading Mode&ndash;&gt;-->
<!--  <div *ngIf="!resources"-->
<!--       class="flex layout-row layout-align-center-center">-->
<!--    <div class="spinner-border" role="status">-->
<!--      <span class="sr-only"></span>-->
<!--    </div>-->
<!--  </div>-->

<!--</div>-->


<div class="col full-height layout-column">


  <cdk-virtual-scroll-viewport *ngIf="!!resources && !!resources?.length"
                               class="flex"
                               autosize
                               [minBufferPx]="600"
                               [maxBufferPx]="1200"
                               (scroll)="onScroll($event)">

    <app-planning-draft-resources-panel-list-item *cdkVirtualFor="let resource of resources; trackBy: trackById"
                                                  cdkDropList
                                                  [cdkDropListData]="routesMap[resource.id]"
                                                  [id]="resource.id"
                                                  [cdkDropListConnectedTo]="connectedPanelIds"
                                                  (cdkDropListDropped)="onDrop(resource, $event)"
                                                  [draft]="draft"
                                                  [resource]="resource"
                                                  [resourceRoutes]="routesMap[resource.id]"
                                                  [settings]="settings"
                                                  (onEditResourceAllocation)="onEditResourceAllocation.emit($event)"
                                                  [isSelected]="selectedKeys[resource.id]"
                                                  [itemElementSize]="itemElementSize"
                                                  (onToggle)="onToggleSelectedResource(resource.id, $event)"
                                                  (onDispatch)="onDispatch.emit($event)"
                                                  (onDrilldown)="onDrilldown.emit($event)">

    </app-planning-draft-resources-panel-list-item>

  </cdk-virtual-scroll-viewport>


  <div *ngIf="!resources?.length"
       class="flex layout-row layout-align-center-center fade-element-in-only overflow-auto">
    <app-empty-state src="assets/images/empty_state/empty_state_drivers.png"
                     text="No Resources Found">

    </app-empty-state>
  </div>

<!--  <div *ngIf="!!resources && !resources?.length"-->
<!--       class="flex layout-row layout-align-center-center fade-element-in-only overflow-auto">-->
<!--    <app-empty-state src="assets/images/empty_state/empty_state_drivers.png"-->
<!--                     text="No Resources Found">-->

<!--    </app-empty-state>-->
<!--  </div>-->

<!--  &lt;!&ndash;Loading Mode&ndash;&gt;-->
<!--  <div *ngIf="!resources"-->
<!--       class="flex layout-row layout-align-center-center">-->
<!--    <div class="spinner-border" role="status">-->
<!--      <span class="sr-only"></span>-->
<!--    </div>-->
<!--  </div>-->

</div>
